<template>
    <Head title="Meu Perfil (MFA)" />
    <AuthenticatedLayout>
        <Heading title="Meu Perfil (MFA)" class="px-4 xl:px-[15.5vw] pt-24" />
        <article
            class="component-background-desktop component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw] min-h-[80vh]"
        >
            <button
                @click="goBack"
                :class="stateBack"
                class="back-sm hover:text-blue-600 hover:underline text-blue-300"
            >
                Voltar
            </button>
            <section v-if="isEnabled">
            <div
                class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px]"
            >
                <h2 class="text-3xl font-semibold text-secondary text-lef">
                    Multiplo Fator de Autenticação
                </h2>
                    <p class="text-md pb-4">
                        Gerêncie por onde você quer ser notificado para autorizar ações em seu acesso
                    </p>

                    <form  @submit.prevent="submit" class="mb-4">
                        <ul class="pt-6">
                            <li class="mb-4">
                                <label class="flex font-bold"
                                    >Email de Contato</label
                                >
                                <Input
                                    placeholder="Ex: Celular, Notebook..."
                                    :state="inputState"
                                    v-model="form.contact"
                                    type="text"
                                    required
                                    autofocus
                                    class="text-black"
                                />
                            </li>

                            <li>
                                <Button @click.prevent="submit"
                                    >Registar Método de Autenticação</Button
                                >
                            </li>
                        </ul>
                    </form>

                    <div v-if="$page.props.flash.error">
                        {{ $page.props.flash.error }}
                    </div>

                    <div v-if="$page.props.flash.success">
                        {{ $page.props.flash.success }}
                    </div>
                </div>
                <div
                    class="sm:px-5 xl:max-w-[700px] xl:min-w-[350px]"
                >
                    <h2 class="text-3xl font-semibold text-secondary text-lef">
                        Lista de Métodos Cadastrados
                    </h2>
                    <div class="p-[1rem] grid grid-cols-3 text-center w-full">
                        <p class="font-black border-r pb-5">Tipo</p>
                        <p class="font-black border-r pb-5">Contato</p>
                        <p class="font-black pb-5">Excluir</p>
                    </div>
                    <div class="p-[1rem] table rounded w-full" style="background: white">
                        <div
                            v-for="(data, key) in credential.credentialauthenticationmethods"
                            :key="key"
                            class="grid grid-cols-3 grid-cols-list-clientes items-center"
                        >
                            <div class="border-r p-4 border-gray-300">
                                <p class="font-black text-black">
                                    {{ data.authenticationmethod.name }}
                                </p>
                            </div>
                            <div class="border-r p-4 border-gray-300">
                                <p class="font-black text-black">
                                    {{ data.contact }}
                                </p>
                            </div>

                            <div
                                class="border-r grid items-center justify-center p-4 border-gray-300"
                            >
                                <a
                                    :href="
                                        route(
                                            'my-profile.mfa.delete-authenticationmethod',
                                            data.id
                                        )
                                    "
                                    class="table bg-gray-100 p-3 rounded text-black"
                                >
                                    <Icon name="Excluir" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-else>
                <p class="text-md pb-4">
                    Funcionalidade desabilitada
                </p>
            </section>
        </article>
        <MFAModal v-if="isAuthorizeModalOpen"
            :credentialauthenticationmethods="credential.credentialauthenticationmethods"
            :accessTo="authorizeModal.accessTo"
            :showModal="isAuthorizeModalOpen"
            :defaultCredentialAuthenticationMethodId="authorizeModal.defaultCredentialAuthenticationMethodId"
            :defaultCredentialAuthorizationId="authorizeModal.defaultCredentialAuthorizationId"
            :defaultContact="authorizeModal.defaultContact"
            @onCancel="cancelAuthorizationModalEvent"
            @onSuccess="successAuthorizationModalEvent" />
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Input from "@/Components/UI/Form/Input.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Back from "@/Components/UI/Back.vue";
import Button from "@/Components/Button.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import MFAModal from "@/Components/MFA/Modal.vue";
import { formatUpdatedDate } from "@/Helpers/masks";
import getBrowserFingerprint from "get-browser-fingerprint";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Back,
        Input,
        Button,
        Icon,
        MFAModal,
    },
    props: {
        authenticationMethods: Object,
        credential: Object,
    },
    data() {
        return {
            showSuccessModal: false,
            isAuthorizeModalOpen: false,
            defaultAuthorizeModal: {
                defaultCredentialAuthorizationId: '',
                defaultCredentialAuthenticationMethodId: '',
                accessTo: 'confirmation',
                defaultContact: '',
            },
            authorizeModal: {
                defaultCredentialAuthorizationId: '',
                defaultCredentialAuthenticationMethodId: '',
                accessTo: 'confirmation',
                defaultContact: '',
            },
            createdCredentialAuthenticationMethodId: '',
            createdCredentialAuthorizationId: '',
            confirmPassword: "",
            form: this.$inertia.form({
                contact: "",
            }),
        };
    },
    mounted() {
        this.mount();
    },
    computed: {
        browserFingerprint() {
            return getBrowserFingerprint();
        },
        isEnabled() {
            return this.authenticationMethods?.length > 0 && this.credential?.id;
        },
        emailAuthenticationMethod() {
            return this.authenticationMethods?.find(({ authenticationmethod }) => authenticationmethod?.name?.toUpperCase() === 'EMAIL');
        },
    },
    methods: {
        mount() {
            this.resetAuthorizationModalObject();
        },
        resetAuthorizationModalObject() {
            this.authorizeModal = this.defaultAuthorizeModal;
        },
        closeAuthorizationModal() {
            this.isAuthorizeModalOpen = false;
        },
        openAuthorizationModal() {
            this.isAuthorizeModalOpen = true;
        },
        cancelAuthorizationModalEvent() {
            this.closeAuthorizationModal();
            this.resetAuthorizationModalObject();
        },
        successAuthorizationModalEvent() {
            this.closeAuthorizationModal();
            this.resetAuthorizationModalObject();
            location.reload()
        },
        submit() {
            if (this.form.contact && this.form.contact.trim() !== "") {
                axios
                    .post(this.route("mfa.create-authenticationmethod"), {
                        authenticationmethodId: this.emailAuthenticationMethod.authenticationmethod?.id,
                        contact: this.form.contact,
                        fingerprintHash: this.browserFingerprint,
                    })
                    .then(({ data }) => {
                        const error = data.error;
                        this.$page.props.flash.error = '';

                        if (error) {
                            const errorMessage = data.data.message;
                            this.$page.props.flash.error = errorMessage;
                        } else {
                            this.openAuthorizationModal();
                            this.authorizeModal.defaultCredentialAuthenticationMethodId = data.id;
                            this.authorizeModal.defaultCredentialAuthorizationId = data.credentialauthorizationId;
                            this.authorizeModal.defaultContact = data.contact;
                        }
                    })
                    .catch(function (error) {
                        console.log("Erro:", error);
                    });
            }
        },
        goBack() {
            return window.history.go(-1);
        },
        formatUpdatedDate,
    },
};
</script>
